import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import Dropzone from 'react-dropzone';
import * as _ from 'lodash';
import { translateObject } from '../../../services/translate/customTranslateService';
import * as bookActions from '../../../actions/bookActions';
import NewUnitCard from '../NewUnitCard';
import { ACTIVITY_TYPE, DRAWER_CONTENTS, ROLE, ROUTES, ROUTES_CONSTANTS, MAX_LENGTH_VARIABLES } from '../../../const';
import * as drawerActions from '../../../actions/drawerActions';
import * as libraryActions from '../../../actions/libraryActions';
import LessonCard from '../LessonCard';
import NewContentCard from '../NewContentCard';
import DragAndDropContainer from '../../common/DragAndDropContainer';
import * as messageAlert from '../../../actions/messageAlertAction';
import * as googleClassroomActions from '../../../actions/googleClassroomActions';
import * as bookService from '../../../services/domain/bookService';
import SadMonster from '../../common/EmptyListPlaceholder/SadMonster';
import * as optionItemsFactory from '../../../factory/optionItemsFactory';
import { getAcceptedMimetypes } from '../../../services/mimetypes/mimetypesService';
import GroupAssignedTile from '../../common/GroupAssignedTile';
import RadioContainer from '../../library/RadioContainer';
import * as gradebookActions from '../../../actions/classroom/gradebookActions';
import routerHistory from './../../../routerHistory';
import { isElectronApp } from '../../../services/crossPlatform/crossPlatformService';
import Media from 'react-media';
import MoreOptions from '../../common/sheets/MoreOptions';
import EditNameSheet from '../../common/sheets/EditNameSheet';
import { isMobileViewport, MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';
import LinkedContentTrigger from '../desynchronizeBook/LinkedContentTrigger';
import { ANALYTICS_CONTEXT, ANALYTICS_EVENT } from '../../../types/analytics';
import * as analyticsApi from '../../../services/api/analyticsApi';

export class UnitCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isDragDisabled: false,
      checked: false,
      isEditSheetOpen: false
    };
  }

  referencesObject = {};

  componentDidMount() {
    const { language, unit, bookActions } = this.props;
    this.setState({ name: translateObject(unit.name, language) });
    bookActions.setSelectedUnit();
  }

  componentWillUnmount() {
    const { bookActions } = this.props;
    bookActions.setOpenUnit();
  }

  componentDidUpdate() {
    const { id, unitEdition, openUnit, unit, bookActions } = this.props;
    let isEditing = unitEdition === id;
    if (isEditing) {
      this.referencesObject[`editionInput${id}`].focus();
    }
    if (openUnit === id && unit.activityId) {
      bookActions.setSelectedUnit(unit);
    }
  }

  static handleOnClickInput = ev => {
    ev.stopPropagation();
  };

  changeDrag = disabled => {
    this.setState({ isDragDisabled: disabled });
  };

  handleChangeName = ev => {
    this.setState({ name: ev.target.value });
  };

  handleKeyPress = ev => {
    const { messageAlert } = this.props;
    const name = this.state.name;
    const nameMaxLength = MAX_LENGTH_VARIABLES.UNIT_NAME;
    if (ev.key === 'Enter') {
      ev.preventDefault();

      if (name.length > nameMaxLength) {
        messageAlert.error(
          I18n.t('error.valueLength', { variable: I18n.t('common.unitTitle'), length: nameMaxLength })
        );
        return;
      } else {
        this.updateName();
        messageAlert.success(`"${name}" ${I18n.t('common.bookSaved')}`);
      }
    }
  };

  clickOut = () => {
    const { messageAlert } = this.props;
    const name = this.state.name;
    const nameMaxLength = MAX_LENGTH_VARIABLES.UNIT_NAME;

    if (name.length > nameMaxLength) {
      messageAlert.error(I18n.t('error.valueLength', { variable: I18n.t('common.unitTitle'), length: nameMaxLength }));
      return;
    } else {
      this.updateName();
      messageAlert.success(`"${name}" ${I18n.t('common.bookSaved')}`);
    }
  };

  handleUnitVisibility = () => {
    const { bookActions, idBook, idClassroom, unit, isAppOnline } = this.props;

    if (isAppOnline) {
      let activityId = unit.activityId;
      let bookId = idBook;
      let classroomId = idClassroom;

      if (unit.disabled) {
        bookActions.enableBookLevel(classroomId, bookId, activityId, ANALYTICS_CONTEXT.UNIT_SHOW);
      } else {
        bookActions.disableBookLevel(classroomId, bookId, activityId, ANALYTICS_CONTEXT.UNIT_HIDE);
      }
    }
  };

  updateName = () => {
    const { bookActions, idBook, idClassroom, unit } = this.props;
    let updatedUnitName = this.state.name;
    bookActions.updateUnitName(idBook, idClassroom, unit.activityId, updatedUnitName).then(() => {
      bookActions.setUnitEdition();
    });
  };

  editUnit = () => {
    const { id, bookActions, isAppOnline } = this.props;

    if (isAppOnline && isMobileViewport()) {
      this.setState({ isEditSheetOpen: true });
      return;
    }

    if (isAppOnline) {
      setTimeout(() => {
        this.referencesObject[`editionInput${id}`].focus();
      }, 0);
      bookActions.setUnitEdition(id);
    }
  };

  saveNameFromSheet = name => {
    const { messageAlert } = this.props;
    this.setState({ name, isEditSheetOpen: false }, () => {
      this.updateName();
      messageAlert.success(`"${name}" ${I18n.t('common.bookSaved')}`);
    });
  };

  selectCourseToShareInGoogle = () => {
    const { drawerActions, unit, googleClassroomActions } = this.props;
    googleClassroomActions.setContent(unit, ACTIVITY_TYPE.UNIT);
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.SELECT_COURSE_GOOGLE);
  };

  openUnitCard = () => {
    const { id, openUnit, isDraggable, bookActions, unit, isNotCloseable } = this.props;

    if (!isDraggable && !isNotCloseable) {
      if (openUnit !== id) {
        bookActions.setOpenUnit(id);
        bookActions.setSelectedUnit(unit);
      } else {
        bookActions.setOpenUnit();
        bookActions.setSelectedUnit();
      }
    }
    bookActions.setSelectedUnit();
  };

  editAssign = () => {
    const { isAppOnline, drawerActions, unit, bookActions, book } = this.props;
    if (isAppOnline) {
      bookActions.setSelectedResource(Object.assign({ isUnit: true, bookAssign: book.configuration }, unit));
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.ASSIGN_STUDENTS);
    }
  };

  seeResourcesPreview = () => {
    const { isAppOnline, drawerActions, unit, bookActions, book, idClassroom } = this.props;
    if (isAppOnline) {
      bookActions.setSelectedResource(Object.assign({ isUnit: true, bookAssign: book.configuration }, unit));
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.RESOURCES_PREVIEW);
      analyticsApi.trackAnalyticsEvent({
        event: ANALYTICS_EVENT.VIEW_UNIT_FILES,
        classId: idClassroom,
        unitId: unit.activityId,
        // On mobile the option comes from the unit options sheet
        context: isMobileViewport() ? ANALYTICS_CONTEXT.UNIT_FILES_SHEET : ANALYTICS_CONTEXT.UNIT_FILES_PREVIEW,
        status: 'success'
      });
    }
  };

  getUnitOptionItems = () => {
    const {
      unit,
      authoring,
      // deleteCatalogContentAllowed,
      deleteCatalogUnitAllowed,
      isComplete,
      allowShareInGoogleClassroom,
      isNotCloseable,
      role,
      menuRoutes,
      isAppOnline
    } = this.props;
    let visibilityText = unit.disabled ? I18n.t('common.option.show') : I18n.t('common.option.hide');
    let visibilityIcon = unit.disabled ? 'custom-icons-eye-view' : 'custom-icons-no-eye-view';
    let options = [];
    if (!authoring || role !== ROLE.INSTRUCTOR) {
      return options;
    }
    options = [optionItemsFactory.getAssignItem(this.editAssign, isAppOnline)];
    if (menuRoutes.includes(ROUTES_CONSTANTS.GRADEBOOK)) {
      options.push(optionItemsFactory.seeGradesItem(this.goToGradebook, isAppOnline));
    }
    options.push(optionItemsFactory.getEditItem(this.editUnit, isAppOnline));
    if (allowShareInGoogleClassroom && !isElectronApp()) {
      options.push(optionItemsFactory.shareInGoogleClassroom(this.selectCourseToShareInGoogle, isAppOnline));
    }
    if (isComplete && !isNotCloseable) {
      options.push(
        optionItemsFactory.getVisibilityItem(visibilityText, visibilityIcon, this.handleUnitVisibility, isAppOnline)
      );
    }
    options.push(optionItemsFactory.seeResourcesPreview(this.seeResourcesPreview, isAppOnline));
    if (deleteCatalogUnitAllowed || !unit.fromCatalog) {
      options.push(optionItemsFactory.getDeleteItem(this.deleteActivity, isAppOnline));
    }
    return options;
  };

  goToGradebook = () => {
    const { idClassroom, book, unit, gradebookActions } = this.props;
    gradebookActions.setData(idClassroom, book, unit);
    routerHistory.push(ROUTES.GRADEBOOK.replace('_classId_', idClassroom));
  };

  renderNoLessonsPlaceholder = () => {
    const { unit, isComplete } = this.props;
    if (!isComplete && unit.content && !unit.content.length) {
      return (
        <div className="no-lessons">
          <SadMonster msgKey="unitCard.noLessons" />
        </div>
      );
    }
  };

  deleteActivity = () => {
    const { bookActions, idClassroom, idBook, unit, isAppOnline } = this.props;
    if (isAppOnline) {
      if (unit.content.length) {
        bookActions.setDeleteUnitData(unit);
      } else {
        bookActions.deleteActivity(idBook, idClassroom, unit.activityId);
      }
    }
  };

  renderLessonsContainerForRole = () => {
    let lessons;
    const { id, openUnit, unit, isComplete } = this.props;
    let displayLessonsClass = '';

    let lessonContainer;

    if (openUnit === id && unit.activityId) {
      displayLessonsClass = 'show';
    }

    if (isComplete) {
      lessonContainer = this.renderLessonsContainerDropZone();
    } else {
      lessonContainer = this.renderLessonsContainer();
    }

    if (unit.content) {
      lessons = (
        <div ref="container" className={`display-lesson-container ${displayLessonsClass}`}>
          {lessonContainer}
        </div>
      );
    }

    return lessons;
  };

  renderLessonsContainer = () => {
    return (
      <div className="lesson-container">
        {this.renderLessons()}
        {this.renderNoLessonsPlaceholder()}
      </div>
    );
  };

  renderLessonsContainerDropZone = () => {
    const { id, mimetypes, mimetypePolicy } = this.props;

    return (
      <Dropzone
        ref={`${id}dropZoneLesson`}
        disableClick={true}
        multiple={false}
        accept={getAcceptedMimetypes(mimetypes, mimetypePolicy)}
        onDrop={this.postFile}
        style={{ width: '100%' }}
      >
        {this.renderLessonsContainer()}
      </Dropzone>
    );
  };

  renderCard = card => {
    let { item, isDragging, data } = card;
    let { isComplete, isPreview } = this.props;
    const lessonActivityId = bookService.removeNotAllowedCharactersToActivityId(item.activityId);

    return (
      <LessonCard
        changeDrag={this.changeDrag}
        idClassroom={data.idClassroom}
        idBook={data.idBook}
        lesson={item}
        id={lessonActivityId}
        unit={data.unit}
        isComplete={isComplete}
        isPreview={isPreview}
        parentId={data.unit.activityId}
        lessons={data.unit.content}
        isDragging={isDragging}
        isNotCloseable={this.props.isNotCloseable}
      />
    );
  };

  renderStaticCard = () => {
    let customMessage = I18n.t('common.newLesson');
    return (
      <div className="row-lesson-card">
        <NewContentCard
          customMessage={customMessage}
          customCss="lesson-card-new no-user-selection"
          onClick={this.openRightPanel}
        />
      </div>
    );
  };

  isDraggable = () => {
    const { role, isComplete, isAppOnline, authoring } = this.props;
    return [ROLE.INSTRUCTOR].includes(role) && isAppOnline && isComplete && authoring;
  };

  handlerAfterMoveCard = newLessonsOrder => {
    const { bookActions, idBook, idClassroom, unit } = this.props;

    if (!_.isEqual(unit.content, newLessonsOrder) && newLessonsOrder.length > 1) {
      unit.content = newLessonsOrder;
      bookActions.updateBookStructure(idClassroom, idBook, unit.activityId, newLessonsOrder);
    }
  };

  postFile = async (accepted, rejected) => {
    const { messageAlert } = this.props;

    if (rejected.length && !accepted.length) {
      const f = rejected[0];
      messageAlert.warning(`${I18n.t('upload.unsupported')}: ${f.name}`);
      return;
    }

    if (accepted.length) {
      const { bookActions, idBook, idClassroom, selectedUnit, user, customer } = this.props;

      const bookContext = {
        idClassroom,
        idBook,
        unitActivityId: selectedUnit.activityId
      };
      bookActions.addDocLesson(accepted, user._id, customer.id, bookContext);
    }
  };

  openRightPanel = () => {
    const { drawerActions, id, bookActions, unit } = this.props;
    bookActions.setNewLessonUnitId(unit.activityId);
    bookActions.setNewLessonUnitRef(this.refs[`${id}dropZoneLesson`]);
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.LESSON_CREATE);
  };

  renderLessons = () => {
    const { idClassroom, idBook, unit, isComplete } = this.props;

    let content;
    let renderStaticCard;

    if (isComplete) {
      renderStaticCard = this.renderStaticCard.bind(this);
    }

    if (unit.content) {
      let data = { unit: unit, idClassroom: idClassroom, idBook: idBook };

      content = (
        <Media query={MOBILE_MEDIA_QUERY}>
          {isMobile =>
            isMobile
              ? this.renderMobileLessons(data, renderStaticCard)
              : this.renderDraggableLessons(data, renderStaticCard)
          }
        </Media>
      );
    }

    return content;
  };

  // Mobile: plain vertical list, no drag and drop (the container positions cards absolutely by measuring them)
  renderMobileLessons = (data, renderStaticCard) => {
    const { unit, authoring } = this.props;
    return (
      <div className="lesson-list-mobile">
        {unit.content.map(item => (
          <React.Fragment key={item.activityId}>{this.renderCard({ item, data, isDragging: false })}</React.Fragment>
        ))}
        {authoring && renderStaticCard && renderStaticCard()}
      </div>
    );
  };

  renderDraggableLessons = (data, renderStaticCard) => {
    const { unit, id, authoring } = this.props;
    return (
      <DragAndDropContainer
        cardId="activityId"
        cards={unit.content}
        rotation={5}
        renderStaticCard={authoring ? renderStaticCard : undefined}
        containerClassName=""
        renderCard={this.renderCard}
        dragActivated={this.isDraggable() && !this.state.isDragDisabled}
        handlerAfterMoveCard={this.handlerAfterMoveCard}
        data={data}
        id={`unitDragAndDropContainer${id}`}
      />
    );
  };

  renderTitle = () => {
    const { name } = this.state;
    const { id, isDraggable, language, unit, unitEdition, groups, role } = this.props;
    let displayH = { display: unitEdition !== id ? 'block' : 'none' };
    let displayInput = { display: unitEdition === id ? 'block' : 'none' };
    let unitCardText = unit.disabled ? 'unit-card-text disabled' : 'unit-card-text';

    return (
      <div id={`unit-dropdown-${id}-title`} className={unitCardText} onClick={this.openUnitCard}>
        <div className="unit-title" style={displayH}>
          {translateObject(unit.name, language)}
        </div>
        <input
          className="no-user-selection"
          style={displayInput}
          ref={ref => (this.referencesObject[`editionInput${id}`] = ref)}
          value={name}
          onChange={this.handleChangeName}
          onKeyPress={this.handleKeyPress}
          onBlur={this.clickOut}
          disabled={isDraggable}
          onClick={UnitCard.handleOnClickInput}
        />
        <span>
          <GroupAssignedTile assignedGroup={unit.configuration} groups={groups} role={role} />
        </span>
      </div>
    );
  };

  getSheetOverline = () => {
    const { book, language } = this.props;
    const bookName = book && book.name ? translateObject(book.name, language) : '';
    return bookName ? `${I18n.t('mobileSheets.unit')} · ${bookName}` : I18n.t('mobileSheets.unit');
  };

  onUnitCheck = () => {
    this.setState({ ...this.state, checked: !this.state.checked });
    const { selectedUnitId, libraryActions } = this.props;
    if (selectedUnitId === this.props.unit.activityId) {
      libraryActions.removeUnitId(this.props.unit.activityId);
    } else {
      libraryActions.addUnitId(this.props.unit.activityId);
    }
  };

  openNewUnitDrawer = () => {
    this.props.drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.UNIT_CREATE);
  };

  render() {
    const {
      id,
      openUnit,
      isComplete,
      unit,
      unitEdition,
      idBook,
      idClassroom,
      authoring,
      order,
      isNotCloseable,
      role,
      isAppOnline,
      isPreview,
      // isEncapsulated,
      creatingUnit,
      language
    } = this.props;
    const { isEditSheetOpen, name } = this.state;

    let optionItems = this.getUnitOptionItems();

    let classEdition = unitEdition === id ? 'edit' : '';
    let unitCardVisibility = unit.disabled ? 'disabled' : '';
    let styleUnit = { borderBottom: openUnit === id ? 'solid 1px #ccc' : '' };

    const unitId = bookService.removeNotAllowedCharactersToActivityId(unit.activityId);

    let areNewUnitsComplete = isComplete && authoring && !isNotCloseable;
    const position = order.indexOf(id) + 1;

    return (
      <div id={`unit-dropdown-${id}`} className="no-user-selection" style={{ width: '100%' }}>
        <div>
          <div className={`unit-card ${classEdition} ${unitCardVisibility}`} style={styleUnit}>
            {this.renderTitle()}
            {!isPreview && authoring && role === ROLE.INSTRUCTOR && (
              <div className="unit-card-options">
                <LinkedContentTrigger
                  activityId={unit.activityId}
                  sectionId={this.props.classroom?.sectionId}
                  linked={unit.linked}
                />
                <MoreOptions
                  id={unitId}
                  color="gray"
                  dropdownSide="left"
                  options={optionItems}
                  sheetTitle={translateObject(unit.name, language)}
                  sheetOverline={this.getSheetOverline()}
                  sheetMedia={
                    <span className="sheet-media-icon sheet-media-icon--unit">
                      <i className="custom-icons-directory" />
                    </span>
                  }
                />
              </div>
            )}
            {creatingUnit && isPreview && (
              <div className="unit-card-options">
                <RadioContainer
                  hideLabel={true}
                  checkId={unitId}
                  checked={this.props.selectedUnitId === unit.activityId}
                  onCheck={() => this.onUnitCheck()}
                />
              </div>
            )}
          </div>
          <NewUnitCard
            isComplete={areNewUnitsComplete}
            position={position}
            idBook={idBook}
            idClassroom={idClassroom}
            onClick={this.openNewUnitDrawer}
          />

          <div>{this.renderLessonsContainerForRole()}</div>
        </div>
        {authoring && role === ROLE.INSTRUCTOR && (
          <EditNameSheet
            open={isEditSheetOpen}
            title={I18n.t('mobileSheets.editUnit')}
            initialValue={name}
            maxLength={MAX_LENGTH_VARIABLES.UNIT_NAME}
            onSave={this.saveNameFromSheet}
            onClose={() => this.setState({ isEditSheetOpen: false })}
          />
        )}
      </div>
    );
  }
}

UnitCard.propTypes = {
  mimetypePolicy: PropTypes.string,
  mimetypes: PropTypes.string,
  idBook: PropTypes.string,
  isComplete: PropTypes.bool,
  isPreview: PropTypes.bool,
  isNotCloseable: PropTypes.bool,
  id: PropTypes.any,
  book: PropTypes.object,
  openUnit: PropTypes.any,
  isDraggable: PropTypes.any,
  bookActions: PropTypes.any,
  gradebookActions: PropTypes.any,
  unit: PropTypes.any,
  language: PropTypes.any,
  unitEdition: PropTypes.any,
  idClassroom: PropTypes.any,
  isAppOnline: PropTypes.any,
  authoring: PropTypes.any,
  user: PropTypes.any,
  customer: PropTypes.object,
  drawerActions: PropTypes.any,
  order: PropTypes.any,
  deleteCatalogUnitAllowed: PropTypes.any,
  messageAlert: PropTypes.object,
  selectedUnit: PropTypes.object,
  groups: PropTypes.array,
  role: PropTypes.string,
  creatingUnit: PropTypes.bool,
  menuRoutes: PropTypes.any
};

function mapStateToProps(state) {
  return {
    mimetypePolicy: state.account.configuration.mimetypePolicy,
    mimetypes: state.account.configuration.mimetypes,
    book: state.book.book,
    language: state.account.user.language,
    openUnit: state.book.openUnit,
    unitEdition: state.book.unitEdition,
    groups: state.classrooms.selectedClassroom.groups,
    user: state.account.user,
    customer: state.school.school.customer,
    selectedUnit: state.book.selectedUnit,
    isAppOnline: state.connection.status.online,
    authoring: state.account.configuration.authoring,
    allowShareInGoogleClassroom: state.account.configuration.allowShareInGoogleClassroom,
    deleteCatalogUnitAllowed: state.account.configuration.deleteCatalogUnitAllowed,
    classroom: state.classrooms.selectedClassroom.classroom,
    role: state.classrooms.selectedClassroom.classroom.role,
    selectedUnitId: state.library.selectedUnitId,
    menuRoutes: state.theme.layoutSettings.teacherSettings.classroomSections.menuRoutes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    googleClassroomActions: bindActionCreators(googleClassroomActions, dispatch),
    libraryActions: bindActionCreators(libraryActions, dispatch),
    gradebookActions: bindActionCreators(gradebookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitCard);
